"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Analytics/Learner/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Wrapper_template = require("../../../../components/Wrapper/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Wrapper_tag = marko_loadTag(Wrapper_template);

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_tag({
      renderBody: function(out) {
        out.t("Learner Analytics");
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
